import { useMemo } from 'react'

import { useSearchParams } from '../../../hooks/useSearchParams'

type SearchParamSource = {
  gameIds: string | string[]
  liveEventTags: string[]
  liveEventSecondaryTags: string[]
  motivations: string[]
  archetypes: string[]
  liveEventAppearances: string[]
}

type SearchParamDestination = {
  gameIds: string[]
  liveEventTags: string[]
  liveEventSecondaryTags: string[]
  motivations: string[]
  archetypes: string[]
  liveEventAppearances: string[]
}

export const useLiveEventExamplesSearchParams = () => {
  const mapper = useMemo(
    () => ({
      mapFromUrl: (source: SearchParamSource): SearchParamDestination => {
        return {
          gameIds: Array.isArray(source.gameIds) ? source.gameIds : source.gameIds ? [source.gameIds] : [],
          liveEventTags: source.liveEventTags || [],
          liveEventSecondaryTags: source.liveEventSecondaryTags || [],
          motivations: source.motivations || [],
          archetypes: source.archetypes || [],
          liveEventAppearances: source.liveEventAppearances || [],
        }
      },
      mapToUrl: (destination: SearchParamDestination): SearchParamSource => {
        return {
          gameIds: destination.gameIds || [],
          liveEventTags: destination.liveEventTags || [],
          liveEventSecondaryTags: destination.liveEventSecondaryTags || [],
          motivations: destination.motivations || [],
          archetypes: destination.archetypes || [],
          liveEventAppearances: destination.liveEventAppearances || [],
        }
      },
    }),
    []
  )

  return useSearchParams<SearchParamSource, SearchParamDestination>(mapper)
}
